import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { NOTIFICATION_ID } from "../../constants/Notification";
import UserType from "../../constants/UserType";
import { sendNotificationRequest } from "../../firebase/notification";
import { updateProfileCompletenessPopup } from "../../firebase/popup";
import getProfileCompletenessValue from "../../helper/getProfileCompletenessValue";
import { RootState } from "../../redux/store";
import PopupComponent from "../PopupComponent";

const ProfileCompletionPopup = () => {
  const { user } = useSelector((state: RootState) => state.user);
  const [open, setOpen] = useState<boolean>(false);
  const handleClose = () => {
    setOpen(false);
  };
  const profileCompleteness = getProfileCompletenessValue(user);
  /*   useEffect(() => {
    if (user.uid && open) {
      sendNotificationRequest(
        user.uid,
        user.userType === UserType.Client
          ? NOTIFICATION_ID.OB8L
          : NOTIFICATION_ID.PU3H
      );
    }
  }, [open, user.uid, user.userType]); */

  useEffect(() => {
    if (
      user &&
      user.uid &&
      profileCompleteness.value === 100 &&
      !user.profileCompletionPopup
    ) {
      setOpen(true);
      updateProfileCompletenessPopup(user.uid);
    } else if (!user.uid) {
      handleClose();
    }
  }, [profileCompleteness.value, user]);

  return (
    <PopupComponent
      button1Function={handleClose}
      notificationId={
        user.userType === UserType.Client
          ? NOTIFICATION_ID.PU3L
          : NOTIFICATION_ID.PU4H
      }
      user={user}
      open={open}
      handleClose={handleClose}
    />
  );
};

export default ProfileCompletionPopup;
